import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  Container,
  LoadingBounce,
  Panel,
} from '@michelin/acid-components';

import useCommercialLocation from 'hooks/useCommercialLocation';
import usePermissionsSPP from 'hooks/usePermissionsSPP';
import { ChangeLogEntities } from 'Types';
import LastModified from 'components/ChangeLog/LastModified';
import { PageTitle } from 'Utils/CanvasPageTitle';
import useUtils from '../../hooks/useUtils';
import useCustomer from '../../hooks/useCustomer';
import CommercialLocationPanel from './Panel';
import { CommercialLocation } from './Fields';

interface Props {
  action: 'edit' | 'view' | 'add',
}

export function CommercialLocationDetails(props: Props) {
  const permissions = usePermissionsSPP();
  const history = useHistory();
  const { t } = useTranslation();
  const { stNumber } = useParams<{ stNumber: string }>();
  const { subTitle } = useUtils();
  const commercialQuery = useCommercialLocation(stNumber);
  const customerQuery = useCustomer(stNumber);

  if (commercialQuery.isLoading
    || customerQuery.isLoading
    || commercialQuery.isFetching) return <LoadingBounce style={{ height: '70vh' }} />;

  if (!permissions.allowsAction('location_information.read', true)) {
    history.push('/');
  }

  // If the service addres is same as physical, we show the same address.
  const commercial = commercialQuery.data || {} as CommercialLocation;

  return (
    <>
      <PageTitle
        title={t('Commercial Truck Information')}
        subtitle={subTitle}
        rightItems={(<LastModified entity={ChangeLogEntities.locationInformation} />)}
      />
      <Container>
        <Panel>
          <CommercialLocationPanel
            commercial={commercial}
            customer={customerQuery.data}
            action={props.action}
          />
        </Panel>
      </Container>

    </>
  );
}
